import { Operator } from '@jexop/core';
import { isArray, isBoolean, isNumber, isString } from 'lodash';
import { DateTime, DurationLikeObject } from 'luxon';
import { Nullable } from '../types';
import { formatDuration, UnitDisplay } from '../util';

export const formatDurationOperator: Operator<number | string> = (props): Nullable<number | string> => {
  let minutes = props.minutes;

  if (!isNumber(minutes) && isString(props.start) && isString(props.finish)) {
    const startDt = DateTime.fromISO(props.start);
    const finishDt = DateTime.fromISO(props.finish);

    if (!startDt.isValid || !finishDt.isValid) {
      return null;
    }

    minutes = Math.max(Math.round(finishDt.diff(startDt, 'minutes').minutes), 0);
  }

  if (!isNumber(minutes)) {
    return null;
  }

  const display = isString(props.display) && ['long', 'short', 'narrow'].includes(props.display) ? props.display as UnitDisplay : undefined;
  const shiftTo = isArray(props.shiftTo) ? props.shiftTo as Array<keyof DurationLikeObject> : undefined;
  const roundModes = ['nearest', 'floor', 'ceil'] as const;
  const round = isBoolean(props.round)
    ? props.round
    : (isString(props.round) && roundModes.includes(props.round as typeof roundModes[number]) ? props.round as typeof roundModes[number] : undefined);
  const roundTo = isString(props.roundTo)
    ? props.roundTo as keyof DurationLikeObject
    : undefined;

  return formatDuration(minutes, display, shiftTo, { round, roundTo });
};
